import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "layout__wrapper" }
const _hoisted_2 = { class: "layout__wrapper" }
const _hoisted_3 = { class: "layout__wrapper-inner container" }
const _hoisted_4 = { class: "layout__wrapper" }

import { computed, onBeforeMount, Raw, ref } from 'vue'
import { useRouter } from 'vue-router'

import LoadingSpinner from '@/components/ui/LoadingSpinner.vue'
import LoadingError from '@/components/ui/LoadingError.vue'

import Layout from '@/app/components/Layout.vue'
import BackLink from '@/app/components/BackLink.vue'
import HeaderInternal from '@/app/components/header/Internal.vue'
import ListDocs from '@/app/components/listing/ListDocs.vue'
import ListingPageDescription from '@/app/components/listing/ListingPageDescription.vue'
import ListingPageDescriptionPodcast from '@/app/components/listing/ListingPageDescriptionPodcast.vue'

import DocsSortButtonMobile from '@/app/components/listing/DocsSortButton.mobile.vue'
import CustomListMenu from '@/app/components/custom.lists/CustomListMenu.vue'

import { createListViewByRoute, ListView } from '@/models/docs.list'
import { useWait } from '@/app/composables/useWait'
import { Sentry } from '@/services/sentry'
import { ListItemType } from '@/models/interfaces'

type SectionCssType = {
  [key in ListItemType]: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListPage',
  setup(__props) {

const view = ref<Raw<ListView> | null>(null)

const wait = useWait()
const router = useRouter()

onBeforeMount(async () => {
  await initView()
})

async function initView(): Promise<void> {
  wait.start('Loading List')
  try {
    const route = router.currentRoute.value
    const routeName = route.name as string
    const params = route.params

    view.value = await createListViewByRoute(routeName, params)
    wait.end('Loading List')
  } catch (error: any) {
    console.error(error)
    wait.start('Error Loading List')
    Sentry.captureException(error)
  }
}

function listPageDescriptionComponent(): any {
  if (view.value?.descriptionView?.doc_type === 'podcast') {
    return ListingPageDescriptionPodcast
  }
  return ListingPageDescription
}

/**
 * Return whether or not the current page is a non-standard Custom List listing page.
 */
const showCustomListMenu = computed(() => {
  if (!view.value?.customList) {
    return false
  }

  const isCustomList = view.value.customList.doc_type === 'custom_list'
  const isStandard = view.value.customList.is_standard

  return isCustomList && !isStandard
})

const sectionCss: SectionCssType = {
  article: 'docs-listing--articles',
  book: 'docs-listing--books',
  podcast_episode: 'docs-listing--podcast-episodes',
  podcast: 'docs-listing--podcasts',
  collection: 'docs-listing--collections',
  custom_list: 'docs-listing--custom-lists',
}

function sectionCssClass(): string | void {
  if (!view.value) {
    return
  }
  return sectionCss[view.value.docTypeName()]
}

return (_ctx: any,_cache: any) => {
  return (_unref(wait).is('Loading List'))
    ? (_openBlock(), _createBlock(Layout, { key: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(LoadingSpinner)
          ])
        ]),
        _: 1
      }))
    : (view.value)
      ? (_openBlock(), _createBlock(Layout, {
          key: 1,
          class: "layout--basic"
        }, {
          default: _withCtx(() => [
            _createVNode(HeaderInternal, {
              title: view.value.pageTitle(),
              class: _normalizeClass(view.value.isHeaderCollapsed ? 'header--scroll' : 'header--default')
            }, {
              actions: _withCtx(() => [
                (view.value.docs().isDocSortVisible())
                  ? (_openBlock(), _createBlock(DocsSortButtonMobile, { key: 0 }))
                  : _createCommentVNode("", true),
                (view.value.customList && showCustomListMenu.value)
                  ? (_openBlock(), _createBlock(CustomListMenu, {
                      key: 1,
                      list: view.value.customList
                    }, null, 8, ["list"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title", "class"]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(BackLink, { class: "docs-listing__backlink container" }),
              (view.value.descriptionView)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(listPageDescriptionComponent()), {
                    key: 0,
                    view: view.value.descriptionView
                  }, null, 8, ["view"]))
                : _createCommentVNode("", true),
              _createElementVNode("section", {
                class: _normalizeClass(["docs-listing", sectionCssClass()])
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(ListDocs, { view: view.value }, null, 8, ["view"])
                ])
              ], 2)
            ])
          ]),
          _: 1
        }))
      : (!view.value && _unref(wait).is('Error Loading List'))
        ? (_openBlock(), _createBlock(Layout, { key: 2 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(LoadingError)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
}
}

})